import { render } from "./Decoration.vue?vue&type=template&id=6859e965&scoped=true"
import script from "./Decoration.vue?vue&type=script&lang=js"
export * from "./Decoration.vue?vue&type=script&lang=js"

import "./Decoration.vue?vue&type=style&index=0&id=6859e965&lang=scss&scoped=true"

import exportComponent from "/builds/ct-dev/clickcease/google-health-report-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6859e965"]])

export default __exports__